import { differenceInMinutes, differenceInSeconds } from 'date-fns';
import { SLA_STATUS } from './constants';

export const calculateSLAStatus = (entryTime, slaMinutes, currentTime = new Date()) => {
  const minutesInStage = differenceInMinutes(currentTime, new Date(entryTime));
  const percentageUsed = (minutesInStage / slaMinutes) * 100;
  if (percentageUsed >= 100) return SLA_STATUS.BREACHED;
  if (percentageUsed >= 75) return SLA_STATUS.WARNING;
  return SLA_STATUS.ON_TRACK;
};

export const formatDuration = (entryTime, currentTime = new Date()) => {
  const totalSeconds = differenceInSeconds(currentTime, new Date(entryTime));
  const absSeconds = Math.abs(totalSeconds);
  const hours = Math.floor(absSeconds / 3600);
  const minutes = Math.floor((absSeconds % 3600) / 60);
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
};

export const getStatusColors = (status) => {
  switch (status) {
    case SLA_STATUS.BREACHED: return 'bg-red-50 border-red-200 text-red-700';
    case SLA_STATUS.WARNING: return 'bg-amber-50 border-amber-200 text-amber-700';
    case SLA_STATUS.ON_TRACK:
    default: return 'bg-emerald-50 border-emerald-200 text-emerald-700';
  }
};